// eslint-disable-next-line import/prefer-default-export
export { default as trackOnClick } from './track-click';
